<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="bg-primary text-white">
    <div class="section-container">
      <h2
        class="text-4xl md:text-5xl"
      >{{ $t('Zorgblik Uitzendbureau en Bemiddeling: Maatwerk en kwaliteit in de zorgsector') }}</h2>
      <div class="mt-10 grid md:grid-cols-2 gap-8">
        <div class="bg-opacity-20 bg-white p-6 rounded-lg shadow-lg text-white">
          <h3 class="text-xl font-semibold mb-3">{{ $t('Onze expertise') }}</h3>
          <p
            class="text-lg"
          >{{ $t('Zorgblik Uitzendbureau is gespecialiseerd in het leveren van maatwerkoplossingen voor de zorgsector. We hebben jarenlange ervaring in de gehandicaptenzorg en de geestelijke gezondheidszorg (GGZ), waardoor we de specifieke uitdagingen van deze sectoren goed begrijpen.') }}</p>
        </div>
        <div class="bg-opacity-20 bg-white p-6 rounded-lg shadow-lg text-white">
          <h3 class="text-xl font-semibold mb-3">{{ $t('Onze focus') }}</h3>
          <p
            class="text-lg"
          >{{ $t('Onze focus ligt op het vinden van de best aansluitende professional voor de uitdaging die er ligt. We doen dit door zorg op maat te bieden, waarbij we de balans vinden tussen de behoefte van de klant en de mogelijkheden van onze medewerkers. Zo zorgen we voor een perfecte match tussen vraag en aanbod.') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
